"use client";

import { useEffect, useState } from "react";

/**
 * Универсальный хук, который ждёт гидратации zustand persist
 * и возвращает { hydrated: boolean }
 */
export function useHydratedStore() {
  const [hydrated, setHydrated] = useState(false);

  useEffect(() => {
    // запускается один раз, после того как zustand поднимет persist
    setHydrated(true);
  }, []);

  return hydrated;
}
